<template>
	<div>
		<div
			class="modal fade campaign-tags"
			id="taggable"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Tags(Prestige)</h5>
					</div>
					<div class="modal-body" style ="padding-top :25px" v-if="isLoading">
						<div
						class="spinner-border"
						style="margin:40px auto;display:block;"
						></div>
					</div>
					<div class="modal-body main_form_block" style="margin-top:25px" v-else>
						<!-- <div class="form-group row">
							<div class="col-md-3">
								<label for="name">Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="tags"
								    :options="tagsList"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addTag"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Tags"
								    class="form-control multi-dropdown select_filter"
								    :multiple="true"
								    id="campaignTags"
									:closeOnSelect="false"
										>
								</multiselect>
							</div>
						</div> -->
                        <div class="form-group row">
							<div class="col-md-3">
								<label for="name">Brand Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="brandTags"
								    :options="brandTagList"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="id"
								    @tag="addBrandTag"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Brand Tags"
								    class="form-control multi-dropdown select_filter"
								    :multiple="true"
								    id="campaignTags"
									:closeOnSelect="false"
										>
								</multiselect>
							</div>
						</div>
                        <div class="form-group row">
							<div class="col-md-3">
								<label for="name">Strategy Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="strategyTags"
								    :options="strategyTagList"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="id"
								    @tag="addStrategyTag"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Strategy Tags"
								    class="form-control multi-dropdown select_filter"
								    :multiple="true"
								    id="campaignTags"
									:closeOnSelect="false"
										>
								</multiselect>
							</div>
						</div>
                        <div class="form-group row">
							<div class="col-md-3">
								<label for="name">Country Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="countryTags"
								    :options="countryTagList"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="id"
								    @tag="addCountryTag"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Country Tags"
								    class="form-control multi-dropdown select_filter"
								    :multiple="true"
								    id="campaignTags"
									:closeOnSelect="false"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Segment Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="segmentTags"
								    :options="segmentTagList"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="id"
								    @tag="addSegmentTag"
								    open-direction="bottom"
								    :taggable="false"
								    placeholder="Segment Tags"
								    class="form-control multi-dropdown select_filter"
								    :multiple="true"
								    id="campaignTags"
									:closeOnSelect="false"
										>
								</multiselect>
							</div>
						</div>
					</div>
					

					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" @click="hideModal()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
							<button
								type="button"
								class="btn btn-primary"
								@click = "saveTagsForCampaign()"
								>Save changes
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Multiselect from "vue-multiselect";

	export default {
		name: "PrestigeTagCampaign",
		components: {
			Multiselect
		},
		data() {
			return {
				// tags:[],
				// tagsList:[],
				selectedCampaigns:[],
				campaignsList:[],
				isLoading:false,
                brandTagList:[],
				brandTags:[],
				strategyTagList:[],
				strategyTags:[],
				segmentTagList:[],
				segmentTags:[],
				countryTagList:[],
				countryTags:[]
			};
		},
		mounted() {
			// this.getTagsList()
            this.getPrestigeTagList()
		},
		methods: {
			// addTag(name){
			// 	var pay = { title : name, id:''}
			// 	this.tags.push(pay)
			// 	this.tagsList.push(pay)
			// },
			addBrandTag(name){
				let pay = {title:name,id:'',type:'brand_ams'}
				this.brandTags.push(pay);
				this.brandTagList.push(pay);
			},
			addStrategyTag(name){
				let pay = {title:name,id:'',type:'strategy_ams'}
				this.strategyTags.push(pay);
				this.strategyTagList.push(pay);
			},
			addCountryTag(name){
				let pay = {title:name,id:'',type :'country_ams'}
				this.countryTags.push(pay);
				this.countryTagList.push(pay);
			},
			addSegmentTag(name){
				let pay = {title:name,id:'',type:'segment_ams'}
				this.segmentTags.push(pay);
				this.segmentTagList.push(pay);
			},
			// getTagsList(){
			// 	const vm = this;
			// 	this.$store.dispatch("campaign/getCampTagList", {}).then((res) => {
			// 		vm.tagsList = res
			// 		this.$store.state.listOfTags = vm.tagsList
			// 	})
			// },
            getPrestigeTagList(){
                const vm = this;
                this.$store.dispatch("campaign/getPrestigeTagList",{}).then((res)=>{
                    if(res && Object.keys(res).length){
                        this.brandTagList = res.brand;
						this.strategyTagList = res.strategy;
						this.countryTagList = res.country;
						this.segmentTagList = res.segment;
                    }
                })
            },
			searchFromDb(str){
				let vm =this;
				let queryString = {
					"q": str,
					"resultsPerPage":null,
					"pageNumber":1,
					"sort":"",
					"doNotShowSpinner": true
				}
				this.$store.dispatch("campaign/getCampaignList", queryString).then((res) => {
					vm.campaignsList = res.data
				})
			},
			hideModal(){
				this.brandTags = [];
				this.brandTagList = [];
				this.strategyTags = [];
				this.strategyTagList = [];
				this.countryTags = [];
				this.countryTagList = [];
				this.segmentTags = [];
				this.segmentTagList = [];
				this.selectedCampaigns = [];
				this.campaignsList = [];
				this.$emit('closeModal')
			},
			saveTagsForCampaign(){
				let payload = {
					campaigns: this.$store.state.campaign.campaignToAddToGroupList,
				    tags:this.tags,
					brandTags:this.brandTags,
					strategyTags: this.strategyTags,
					countryTags: this.countryTags,
					segmentTags:this.segmentTags
				}
				this.isLoading = true;
				let vm = this;
				this.$store.dispatch("campaign/savePrestigeBulkTag", payload).then((res) => {
					vm.isLoading = false
					vm.hideModal()
					vm.$store.dispatch("campaign/getCampaignList", {}).then(res => {
							console.log(res);
							vm.getPrestigeTagList();
					});
				})
			}
		}
	};
</script>


<style lang="scss">
.campaign-tags {
	.multiselect__single{
		text-transform: none !important;
		overflow: hidden;
	}
}
.campaign-tags {
	.multiselect__option span{
		text-transform: none !important;
	}
}
.campaign-tags {
	.multiselect__tag{
		text-transform: none !important;
	}
}

</style>
